import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { email } from '../email-validator/email-validator.class';

export class CustomValidators {
    public static email() {
        return email();
    }

    public static matchValidator(
        firstControlName: string,
        secondControlName: string,
        errorMessage: string
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const firstControlValue = control.get(firstControlName)?.value;
            const secondControlValue = control.get(secondControlName)?.value;
            if (firstControlValue && secondControlValue && firstControlValue != secondControlValue) {
                return { [errorMessage]: true };
            }

            return null;
        };
    }

    public static selectRequired(control: AbstractControl): { [key: string]: any } | null {
        const selectValue = control.value;
        if (!selectValue || selectValue.toString() == '0') {
            return { required: true };
        } else {
            return null;
        }
    }
}
